export default {
    ENV_PRODUCTION: 'production',
    ENV_STAGING: 'staging',
    ENV_TEST: 'test',
    ENV_LOCAL: 'local',

    /**
     * Parses the environment from a domain if possible.
     *
     * @param {string} hostName
     * @returns {string|null}
     */
    parseEnvironment: function (hostName) {
        let hostEnvironments = [
            this.ENV_STAGING,
            this.ENV_TEST,
        ];

        const regex = new RegExp(`dashboard-(${ hostEnvironments.join('|') }).mobian.global`);
        const result = regex.exec(hostName);

        if (result) {
            return result[1];
        }

        return null;
    },

    /**
     * Resolves the environment by checking various resoures. Defaults to production.
     *
     * @returns {string}
     */
    resolveEnvironment: function () {
        let defaultEnvironment = this.ENV_PRODUCTION;

        // Check for in development running environment
        if (process.env.NODE_ENV === 'development') {
            return this.ENV_LOCAL;
        }

        // Check the host name to define the environment
        const hostName = window.location.hostname;

        if (hostName.indexOf('localhost') === 0) {
            return this.ENV_LOCAL;
        }

        const parsedEnvironment = this.parseEnvironment(hostName);

        if (parsedEnvironment !== null) {
            return parsedEnvironment;
        }

        return defaultEnvironment;
    },
};



// WEBPACK FOOTER //
// ./src/helpers/environment.js